import React, {useEffect, useState} from 'react';
import {ReactComponent as HomeIcon} from '../../../assets/main/groups/main-top/home.svg';
import {MainTop} from "../groups/group-container/main-top/Main-top";
import {useAppDispatch, useAppSelector} from "common/hook";
import {PersonalCabinetStudent} from "./pesonal-cabinet-container/cabinet-student/PersonalCabinetStudent";
import {PersonalCabinetTeacher} from "./pesonal-cabinet-container/cabinet-teacher/Personal-cabinet-teacher";
import {ROLE_TEACHER} from "entities/constants/constants";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";
import {fetchCabinetData} from "entities/Cabiner/model/featchCabinetData/featchCabinetData";
import {Preloader} from "../../layout/preloader/Preloader";
import {NothingYetMessage} from "./nothing-yet-message/NothingYetMessage";


export const PersonalCabinet = () => {
    const roleType = useAppSelector((state) => state.role.roleType);
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        dispatch(fetchCabinetData())
            .then(() => setIsLoading(false))
            .catch(() => setIsLoading(false));
    }, [dispatch]);

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Личный кабинет'} tabs={false} setting={false} link={'/'} icons={<HomeIcon />} />
                {isLoading ? (
                    <Preloader />
                ) : roleType === ROLE_TEACHER ? (
                    <PersonalCabinetTeacher />
                ) : (
                    <PersonalCabinetStudent />
                )}
                {!isLoading && !roleType && <NothingYetMessage />}
            </div>
        </AuthWrapper>
    );
};
